export const UserEvents = {
  INVITE_SENT: 'invite_sent',
  INVITE_DELETED: 'invite_deleted',
  USER_UPDATED: 'user_updated',
  USER_DELETED: 'user_deleted',
  PILLAR_OWNER_UPDATED: 'pillar_owner_updated'
}
